import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';

import { ShellRoutingModule } from './shell-routing.module';

import { ShellComponent } from './shell/shell.component';

@NgModule({
  imports: [
   CommonModule,
    ShellRoutingModule,
    MatIconModule,
    MatToolbarModule,
    MatSidenavModule,
    MatExpansionModule,
    MatListModule,
    MatDividerModule,
  ],
  declarations: [
    ShellComponent
  ],
  providers:[
    CurrencyPipe
  ]
})
export class ShellModule { }
